export const iconFontAwesomeArrowsAngleDown = (
	<i className="fa-solid fa-angle-down"></i>
);
